import React, { Fragment } from "react";
import _ from "lodash";
import PlayerAccordion from "../PlayerAccordion";
import Link from "@material-ui/core/Link";
import { useForm, useFormState } from "react-final-form";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import BasketballPlayerStats from "./BasketballPlayerStats";
import BasketballTeamStats from "./BasketballTeamStats";
import VolleyballPlayerStats from "./VolleyballPlayerStats";
import VolleyballTeamStats from "./VolleyballTeamStats";
import SoccerTeamStats from "./SoccerTeamStats";
import SoccerPlayerStats from "./SoccerPlayerStats";
import BaseballTeamStats from "./BaseballTeamStats";
import BaseballPlayerStats from "./BaseballPlayerStats";
import { transformDataToForm } from "games/model/transformations";
import { isDisplayable } from "util/misc";
import PlayerStatsCounter from "./PlayerStatsCounter";

const Stats = (props) => {
  const { side, record } = props;
  const { sportCode } = record;
  const dataFromPlaysBlob = transformDataToForm(record);
  const seasonTeamId = _.get(record, [side, "season", "id"]);
  const editRosterHref = `/seasonTeams/${seasonTeamId}/show`;
  const form = useForm();
  const { values } = useFormState();
  const players = _.get(dataFromPlaysBlob, ["stats", side, "playerStats"]);
  const formPlayers = _.get(values, [side, "formPlayers"]);
  const theme = useTheme();
  const classes = makeStyles({
    input: {
      marginRight: theme.spacing(2)
    }
  })();

  // set up the form data so we can use react-admin fields to update the data
  if (!isDisplayable(formPlayers)) {
    players.forEach((player, index) => {
      Object.keys(player).forEach((key) => {
        form.change(`${side}.formPlayers.${index}.${key}`, player[key]);
      });
    });
  }

  let TeamStats;
  let PlayerStats;
  if (sportCode === "girls-basketball" || sportCode === "boys-basketball") {
    TeamStats = BasketballTeamStats;
    PlayerStats = BasketballPlayerStats;
  } else if (sportCode === "girls-soccer" || sportCode === "boys-soccer") {
    TeamStats = SoccerTeamStats;
    PlayerStats = SoccerPlayerStats;
  } else if (sportCode === "softball" || sportCode === "baseball") {
    TeamStats = BaseballTeamStats;
    PlayerStats = BaseballPlayerStats;
  } else if (sportCode === "girls-volleyball") {
    TeamStats = VolleyballTeamStats;
    PlayerStats = VolleyballPlayerStats;
  }

  const getPlayerFields = (i) => {
    const getPlayerSource = (fieldName) => {
      return `${side}.formPlayers.${i}.${fieldName}`;
    };
    return <PlayerStats s={getPlayerSource} />;
  };

  return (
    <Fragment>
      <TeamStats side={side} className={classes.input} />
      <br></br>
      <Link href={editRosterHref} target="blank">
        Edit Roster
      </Link>
      <br></br>
      <br></br>
      <PlayerStatsCounter side={side} sportCode={sportCode} />
      <PlayerAccordion
        players={formPlayers}
        sortPlayers={true}
        namePath="name"
        getPlayerFields={getPlayerFields}
      />
    </Fragment>
  );
};

export default Stats;
